import {createSelector} from '@reduxjs/toolkit';

import {getUserIdFromChannelName} from 'mattermost-redux/utils/channel_utils';

import {ChannelType} from '@mattermost/types/channels';

import {getDirectChannelsSet, getAllChannels} from './channels';
import {getCurrentUserId} from './common';

export const getDmUsers = createSelector(
    getAllChannels,
    getDirectChannelsSet,
    getCurrentUserId,
    (allChannels, directChannelIds, currentUserId) => {
        const userIds = new Set<string>();

        directChannelIds.forEach((channelId) => {
            const channel = allChannels[channelId];

            if (!channel || channel.type !== ChannelType.Direct) {
                return;
            }

            userIds.add(getUserIdFromChannelName(currentUserId, channel.name));
        });

        return userIds;
    });
